import { getTextFixed } from "../translations";
import * as Lookup from "./lookup";
export const WISSELSTELLERS = [
    [0, 0, "PC34540", 0],
    [1, 1, "PC34542", 1],
    [2, 2, "PC34560", 0],
    [3, 3, "PC34562", 1],
    [4, 4, "PC34520", 0],
    [5, 5, "PC34522", 1],
];
export const parse = (row) => {
    const [_key, _description, _art, direction] = row;
    const parsed = {
        key: _key,
        // wissel: undefined,
        // hoek: undefined,
        // profiel: undefined,
        // richting: undefined,
        // boogstraal: undefined,
        // teknrWissel: undefined,
        // teknrComp: undefined,
        artCodeTSNL: _art,
        aantal: 1,
        category: "wisselstellers",
        _description,
        description() { return description(parsed); },
        wisselsteller: Lookup.wisselstellerDirections[direction],
    };
    return parsed;
};
export const description = (row) => {
    // ${getTextFixed("wisselsteller")}
    return `${getTextFixed(Lookup.wisselstellerDescription[row._description])} (${row.artCodeTSNL})`;
};
